export default __webpack_public_path__ + "c39c6f66b0ce651fe2adce531d95d028.png";